import { gql } from '@/core/shared/api';
import { fullStation, tagFragment } from './fragments';

export const getTags = async ({ commit, dispatch }) => {
  commit('setLoading', true);
  commit('tags/set', {
    path: 'isFetchingTags',
    value: true,
  });
  try {
    const query = `{
      tags {
        ${tagFragment}
      }
    }`;
    const data = await gql.request(query);
    if (data) {
      dispatch('insertEntities', {
        name: 'Tag',
        payload: data.tags,
      });
      return data.tags;
    }
  } finally {
    commit('tags/set', {
      path: 'isFetchingTags',
      value: false,
    });
    commit('setLoading', false);
  }
};

export const getLocationStations = async ({ dispatch, commit, rootGetters }, locationId) => {
  commit('setLoading', true);
  commit('stations/set', {
    path: 'isFetchingStations',
    value: true,
  });

  const query = `{
    stations (locationId: "${locationId}") {
      ${fullStation}
    }
  }`;

  try {
    const { stations } = await gql.request(query);

    dispatch('insertEntities', {
      name: 'Station',
      payload: stations,
    });

    const stationIdsFromApi = stations.map(station => station.id);
    rootGetters['entities/Station/all']().forEach(station => {
      if (!stationIdsFromApi.includes(station.id)) {
        dispatch('removeEntities', {
          name: 'Station',
          payload: station,
        });
      }
    });

    return stations;
  } finally {
    commit('setLoading', false);
    commit('stations/set', {
      path: 'isFetchingStations',
      value: false,
    });
  }
};

export const getStation = async ({ commit, dispatch }, stationId) => {
  commit('setLoading', true);
  commit('stations/set', {
    path: 'isFetchingStations',
    value: true,
  });

  const query = `{
    station (stationId: "${stationId}") {
      ${fullStation}
    }
  }`;

  try {
    const { station } = await gql.request(query);

    dispatch('insertEntities', {
      name: 'Station',
      payload: station,
    });

    return station;
  } finally {
    commit('setLoading', false);
    commit('stations/set', {
      path: 'isFetchingStations',
      value: false,
    });
  }
};

export const storeStation = async ({ commit, dispatch }, station) => {
  commit('setLoading', true);

  const mutation = `mutation storeStationMonitor ($station: StationInput) {
    storeStationMonitor (station: $station) {
      ${fullStation}
    }
  }`;

  try {
    const { storeStationMonitor } = await gql.request(mutation, { station });

    dispatch('insertEntities', {
      name: 'Station',
      payload: storeStationMonitor,
    });

    return storeStationMonitor;
  } finally {
    commit('setLoading', false);
  }
};

export const storeStations = async ({ commit, dispatch }, station) => {
  commit('setLoading', true);
  const mutation = `mutation storeStationsMonitor ($station: StationsInput) {
    storeStationsMonitor (station: $station) {
      ${fullStation}
    }
  }`;

  try {
    const { storeStationsMonitor } = await gql.request(mutation, { station });

    dispatch('insertEntities', {
      name: 'Station',
      payload: storeStationsMonitor,
    });

    return storeStationsMonitor;
  } finally {
    commit('setLoading', false);
  }
};

export const restoreStation = async ({ commit, dispatch }, station) => {
  commit('setLoading', true);

  const mutation = `mutation ($station: StationInput) {
    restoreStation (station: $station) {
      ${fullStation}
    }
  }`;

  try {
    const { restoreStation } = await gql.request(mutation, { station });

    dispatch('insertEntities', {
      name: 'Station',
      payload: restoreStation,
    });

    return restoreStation;
  } finally {
    commit('setLoading', false);
  }
};
